import SearchParsingError from "../../models/errors/SearchParsingError";

import angular from "angular";

const mLogSvc = new WeakMap();
const mSearchStringTokenizerSvc = new WeakMap();
const mSyntaxParserSvc = new WeakMap();

class SearchRequestParserService {
    constructor($log, SearchStringTokenizerService, SearchRequestSyntaxParserService) {
        mLogSvc.set(this, $log);
        mSearchStringTokenizerSvc.set(this, SearchStringTokenizerService);
        mSyntaxParserSvc.set(this, SearchRequestSyntaxParserService);
    }

    _buildSearchRequest(searchString) {

        if (!angular.isString(searchString)) {
            throw new TypeError("Cannot parse search strings that are not strings");
        }

        let searchStringTokenizerResult = mSearchStringTokenizerSvc.get(this).tokenizeSearchString(searchString);

        mLogSvc.get(this).debug("Tokenizer Finished.");
        mLogSvc.get(this).debug(searchStringTokenizerResult);

        let searchRequestRoot = mSyntaxParserSvc.get(this).parseTokenizedSearchString(searchStringTokenizerResult);

        mLogSvc.get(this).debug("Parser Finished.");
        mLogSvc.get(this).debug(searchRequestRoot);

        if (searchRequestRoot != null) {
            return {
                version: 1,
                request_root: searchRequestRoot
            };
        }
        else {
            throw new SearchParsingError("An error occurred parsing the search query.");
        }
    }

    toString() {
        return "SearchRequestParserService";
    }

    buildSearchRequest(userSearchString) {
        return this._buildSearchRequest(userSearchString);
    }
}

SearchRequestParserService.$inject = [ "$log", "SearchStringTokenizerService", "SearchRequestSyntaxParserService" ];

export default SearchRequestParserService;



//////////////////
// WEBPACK FOOTER
// ./src/services/search-request-parser/SearchRequestParserService.js
// module id = fRzh
// module chunks = 1